export const APP = 'APP';
export const EMAIL = 'EMAIL';
export const SLACK = 'SLACK';
export const WEBHOOKS = 'WEBHOOKS';
